export default __webpack_public_path__ + "static/InterDisplay-BlackItalic-0eeb0d6d15c69ba37f0065592520430f.woff2";